// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"ProjectMainViewAddFiles_uploadWrapper__3gEJT","contentWrapper":"ProjectMainViewAddFiles_contentWrapper__A_ndD"};